
document.addEventListener("DOMContentLoaded", function () {
  var buttons = document.querySelectorAll(".accordion-button");

  buttons.forEach(button => {
    button.addEventListener("click", function () {

      const content = this.nextElementSibling;
      this.classList.toggle("active");

      // Toggle the display of the accordion content
      if (content.style.display == "block") {
        content.style.display = "none";
      } else {
        content.style.display = "block";
      }

      // Close others when is open
      buttons.forEach(btn => {
        if (btn !== this) {
          btn.nextElementSibling.style.display = "none";
          btn.classList.remove("active");
        }
      })
    })
  })
});